/**
 * 关于用于&权限
 */
export default {
  namespaced: true,

  state: {
    /**
     * 是否存在授权数据
     */
    hasData: false,

    /** 请求token */
    token: null,

    /** 用户个人信息 */
    userInfo: {},

    /** 用户路由权限 */
    uroutes: [],

    /** 用户功能权限 */
    uperms: [],
  },

  mutations: {

  },

  actions: {

    /**
     * 通用设置方法
     * @param context
     * @param opt
     * {
     *   key: state的键
     *   data: 要设置的值
     * }
     **/
    setData(context, opt){
      if(!opt) return;
      context.state[opt.key] = opt.data;
    },

    getData(context, opt){
      // TODO
    },

    /**
     * 清理所授权数据
     **/
    clear(context) {
      context.state.hasData = false;
      context.state.token = null;
      context.state.userInfo = {};
      context.state.uroutes = [];
      context.state.uperms = [];
    }
  }

}
